const UPDATE_REGIONS = 'regions/UPDATE_REGIONS';
const UPDATE_LOADED = 'regions/UPDATE_LOADED';
const SET_SELECTED_REGION = 'regions/SET_SELECTED_REGION';

export default {
  UPDATE_REGIONS,
  UPDATE_LOADED,
  SET_SELECTED_REGION
};
